"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipBenefitBannerWidgetDataSchema = void 0;
var zod_1 = require("zod");
exports.MembershipBenefitBannerWidgetDataSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.object({
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        }),
        image: zod_1.z.object({
            height: zod_1.z.number(),
            width: zod_1.z.number(),
            url: zod_1.z.string(),
        }),
        logMeta: zod_1.z.record(zod_1.z.unknown()),
    })),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
});
